import classNames from 'classnames';
import EcoButtonThree from 'eco-design/base/eco-button-three';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import React from 'react';
import { EcoGraphicSwiperItemProps } from './props';

const EcoGraphicSwiperItem: React.FC<EcoGraphicSwiperItemProps> = (item) => {
    const prefixCls = `eco-graphic-swiper-item`;
    const classes = classNames(prefixCls, {});
    const itemStyle = {
        '--graphic-item-labelColor': item.labelColor,
        '--graphic-item-titleColor': item.titleColor,
        '--graphic-item-descColor': item.descColor,
    } as React.CSSProperties;
    return (
        <div className={classes} style={itemStyle}>
            <div className={`${prefixCls}-img`}>
                <EcoImgVideo isVideo={item.isVideo} pc={item.pc} {...item} />
            </div>
            <div className={`${prefixCls}-msg`}>
                <div className={`${prefixCls}-label`}>{item.label}</div>
                <div className={`${prefixCls}-title`}>{item.title}</div>
                <div className={`${prefixCls}-desc`}>{item.desc}</div>
                <EcoButtonThree {...item} className={`${prefixCls}-btns`} />
            </div>
        </div>
    );
};

export default EcoGraphicSwiperItem;
